<template>
  <TipTap
    :content.sync="content"
    :style-settings="styleSettings"
    iframe-extension
    image-extension
  />
  <!-- no mention extension -->
</template>

<script lang="ts">
import Component from 'vue-class-component'

import TipTap from '@/components/TipTap/TipTap.vue'
import TTEditor from '@/components/TipTap/wrappers/TTEditor.vue'

const components = {
  TipTap,
}

@Component({ components })
export default class TTNoField extends TTEditor {}
</script>
